export default __webpack_public_path__ + "static/media/down-arrow-green.4af8d2fe.svg";